export enum CardType {
  Club = 0,
  Spade = 1,
  Heart = 2,
  Diamond = 3,
}

export enum CardValue {
  Ace = 1,
  Two = 2,
  Three = 3,
  Four = 4,
  Five = 5,
  Six = 6,
  Seven = 7,
  Eight = 8,
  Nine = 9,
  Ten = 10,
  Jack = 11,
  Queen = 12,
  King = 13,
}

export enum CardDisclosureStatus {
  None = 0,
  Pending = 1,
  InProgress = 2,
  Completed = 3,
}

export enum PileId {
  Foundation_01,
  Foundation_02,
  Foundation_03,
  Foundation_04,
  Tableau_01,
  Tableau_02,
  Tableau_03,
  Tableau_04,
  Tableau_05,
  Tableau_06,
  Tableau_07,
  Waste,
  Deck,
}

export enum PileType {
  Deck,
  Waste,
  Foundation,
  Tableau,
}

export enum PointsType {
  PlaceCardsBackToDeck,
  Move,
}
